import { observer } from 'mobx-react';
import Filters from './Filters';
import Table from './Table';
import Footer from './Footer';

export type CheckboxRequirementType = 'required' | 'not-required';
interface Props {
  filterCount: number;
  tableColCount: number;
  checkBoxRequirement: CheckboxRequirementType;
}

function Skeleton({ filterCount, tableColCount, checkBoxRequirement }: Props) {
  return (
    <div className="px-2.5 lg:px-12 py-7">
      <Filters filterCount={filterCount} />
      <Table
        tableColCount={tableColCount}
        checkBoxRequirement={checkBoxRequirement}
        tableRowCount={15}
      />
      <Footer />
    </div>
  );
}

export default observer(Skeleton);
